// A company's allowed sign-in domains, as the server reads them (functions/
// features.js allowedDomainsOf, #75): settings.signIn.allowedDomains, else the
// older single settings.signInDomain; [] = invite-only. ASP's is
// ["aspconsulting.co.uk"]. Pure, so the Add person form and its test share it.
export function allowedDomainsOf(settings) {
  const s = settings || {};
  const list = s.signIn && Array.isArray(s.signIn.allowedDomains) ? s.signIn.allowedDomains
    : (s.signInDomain ? [s.signInDomain] : []);
  return list.map((d) => String(d || '').trim().toLowerCase()).filter(Boolean);
}

/** null when the address may be added, else what to tell the person. */
export function checkWorkEmail(v, domains) {
  const e = String(v || '').trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return 'Enter an email address.';
  if (!domains.length) return null;
  return domains.some((d) => e.endsWith(`@${d}`)) ? null
    : `Use ${domains.length === 1 ? 'an' : 'a work'} ${domains.map((d) => `@${d}`).join(' or ')} address.`;
}
